import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["programSelect", "phaseSelect", "phaseContainer"]

  connect() {
    // Initialize: show/hide phase dropdown based on initial program selection
    this.updatePhaseVisibility()
  }

  async programChanged(event) {
    const programId = event.target.value

    if (!programId) {
      // No program selected - hide phase dropdown and clear selection
      this.phaseContainerTarget.classList.add('hidden')
      this.clearPhaseOptions()
      return
    }

    // Program selected - fetch phases and show dropdown
    await this.loadProgramPhases(programId)
    this.phaseContainerTarget.classList.remove('hidden')
  }

  async loadProgramPhases(programId) {
    try {
      const response = await fetch(`/programs/${programId}.json`)
      const program = await response.json()

      // Clear existing options
      this.clearPhaseOptions()

      // Add default option
      const defaultOption = document.createElement('option')
      defaultOption.value = ''
      defaultOption.textContent = 'Select a phase'
      this.phaseSelectTarget.appendChild(defaultOption)

      // Add phase options
      if (program.phases && program.phases.length > 0) {
        program.phases.forEach(phase => {
          const option = document.createElement('option')
          option.value = phase.id
          option.textContent = phase.name
          this.phaseSelectTarget.appendChild(option)
        })
      }
    } catch (error) {
      console.error('Error loading program phases:', error)
    }
  }

  clearPhaseOptions() {
    this.phaseSelectTarget.innerHTML = '<option value="">Select a phase</option>'
  }

  updatePhaseVisibility() {
    const programId = this.programSelectTarget.value
    if (programId) {
      this.phaseContainerTarget.classList.remove('hidden')
    } else {
      this.phaseContainerTarget.classList.add('hidden')
    }
  }
}
